import { getRouteParams } from '../../routing/getRouteParams';
export const EXT_EXPERIMENT_PARAM = 'external-experiment-parameter';
export const getExternalExperimentParameter = () => {
  const allExternalExperimentParamValues = getRouteParams().queryParamsMap.getAll(EXT_EXPERIMENT_PARAM);
  return allExternalExperimentParamValues;
};